<template>
    <Vue3Lottie v-if="adata" @onAnimationLoaded="loaded" @onLoopComplete="complete" @onComplete="complete" class="d-lottie data" :animationData="adata" :loop="loop" :autoPlay="autoplay" :width="size" :height="size" />
    <Vue3Lottie v-else-if="alink" @onAnimationLoaded="loaded" @onLoopComplete="complete" @onComplete="complete" class="d-lottie link" :animationLink="alink" :loop="loop" :autoPlay="autoplay" :width="size" :height="size" />
</template>

    
<script setup>
/* eslint-disable */
import { computed, defineEmits } from 'vue';
import { Vue3Lottie } from 'vue3-lottie'

const emit = defineEmits(['complete', 'loaded'])

const {src } = defineProps({
    size: { type: Number},
    loop: { type: Boolean, default: true },
    autoplay: { type: Boolean, default: true },
    src: { type: [Object, String], required: true}
})    

const adata = computed(() => typeof src === 'object' ? src: null)
const alink = computed(() => typeof src === 'string' ? src: null)

function complete(){
    emit("complete");
}

function loaded(){
    emit("loaded");
}

</script>
